import { render, staticRenderFns } from "./branchesList.vue?vue&type=template&id=6d67b75d"
import script from "./branchesList.vue?vue&type=script&lang=js"
export * from "./branchesList.vue?vue&type=script&lang=js"
import style0 from "./branchesList.vue?vue&type=style&index=0&id=6d67b75d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports